import { useStore } from 'effector-react'
import { ListInspections } from '~/features/Inspections/ListInspections'
import { rentalContractModel } from '~/entities/RentalContract'
import { PageContainer } from '~/shared/ui/PageContainer'
import { SkeletonList } from '~/shared/ui/SkeletonList'
import { useRefreshPage } from './useRefreshPage'

export function ListInspectionsPage() {
  const { refreshPage } = useRefreshPage()
  const rentalContract = useStore(rentalContractModel.$rentalContract)
  const rentalContractPending = useStore(
    rentalContractModel.getRentalContractFx.pending,
  )

  return (
    <PageContainer
      title='Осмотры'
      backTitle='Осмотры'
      canBack
      preventScrollReset
      onRefreshPage={refreshPage}
    >
      {rentalContractPending && (
        <SkeletonList count={10} skeletonHeight={81} itemMarginBottom='8px' />
      )}

      {!rentalContractPending && rentalContract && <ListInspections />}
      {!rentalContractPending && !rentalContract && (
        <div style={{ fontSize: '18px', marginTop: '40px' }}>
          Для просмотра осмотров у вас должен быть действующий договор аренды!
        </div>
      )}
    </PageContainer>
  )
}
